module.exports = __webpack_public_path__ + "static/media/workflow3.f7e3b710.svg";